import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useUserDataContext } from '../../contexts/userDataProvider';
import { amountOfMonthToReturn } from '../common/appSettings';
import SelectComponent from '../common/SelectComponent';
import { yearsSelectOptions } from './timeLineUtils';

const TimelineFilters = ({ setSelectedDate }) => {
  const { translate } = useUserDataContext();

  const monthsKeys = [
    "jan", "feb", "mar", "apr", "mayShort", "jun",
    "jul", "aug", "sep", "oct", "nov", "dec"
  ];

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth();

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonthIndex);

  const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value, 10));
  };

  const handleMonthChange = (monthIndex) => {
    setSelectedMonth(monthIndex);
  };

  // Single source of truth for timeline range
  useEffect(() => {
    setSelectedDate({
      dateFrom: new Date(selectedYear, selectedMonth, 1),
      dateTo: new Date(
        selectedYear,
        selectedMonth + amountOfMonthToReturn,
        0
      ),
    });
  }, [selectedYear, selectedMonth, setSelectedDate]);

  const mobileSelectMonthsData = monthsKeys.map((month, index) => ({
    name: translate(month),
    value: String(index),
  }));

  return (
    <div className="timelineFiltersWrap">
      {/* Year select */}
      <SelectComponent
        options={yearsSelectOptions}
        handleSelect={handleYearChange}
        value={String(selectedYear)}
      />

      {/* Month buttons */}
      <div className="monthsButtonsWrap">
        {monthsKeys.map((month, index) => (
          <Button
            key={month}
            className={`monthButton ${selectedMonth === index ? "monthButtonSelected" : ""}`}
            node="button"
            onClick={() => handleMonthChange(index)}
          >
            {translate(month)}
          </Button>
        ))}
      </div>

      {/* Mobile month select */}
      <SelectComponent
        className="mobileMonthsSelectWrap"
        options={mobileSelectMonthsData}
        handleSelect={(event) =>
          handleMonthChange(parseInt(event.target.value, 10))
        }
        value={String(selectedMonth)}
      />

      {/* Today button */}
      <Button
        className="todayButton"
        node="button"
        onClick={() => {
          setSelectedYear(currentYear);
          setSelectedMonth(currentMonthIndex);
        }}
      >
        {translate("today")}
      </Button>
    </div>
  );
};

TimelineFilters.propTypes = {
  setSelectedDate: PropTypes.func.isRequired
};

export default TimelineFilters;
